var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "effect-list" },
    [
      _setup.pinnedItem
        ? _c(_setup.ImageEffectsPropertiesListItem, {
            key: _setup.pinnedItem.id,
            attrs: {
              id: 0,
              item: _setup.pinnedItem,
              readonly: _vm.disabled,
              pinned: true,
            },
            on: { update: _setup.handleUpdate, remove: _setup.handleRemove },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        _setup.VueDraggable,
        {
          attrs: {
            list: _setup.sortable.items,
            animation: 300,
            disabled: _vm.disabled,
            "ghost-class": "effect-list__ghost",
            "chosen-class": "effect-list__chosen",
            "drag-class": "effect-list__drag",
          },
          on: { change: _setup.handleReorder },
        },
        [
          _vm._l(_setup.sortable.items, function (element, index) {
            return [
              _c(_setup.ImageEffectsPropertiesListItem, {
                key: element.id,
                attrs: { id: index, item: element, readonly: _vm.disabled },
                on: {
                  update: _setup.handleUpdate,
                  remove: _setup.handleRemove,
                },
              }),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.items.length === 0
        ? _c("div", { staticClass: "effect-list__empty" }, [
            _c("p", [_vm._v("No effects to display")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }